'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');

function CarouselBase(el, itemSelector, options) {
  this.config = _Object$assign({
    duration: 5000,
    currentIndex: 0
  }, options);

  this.$el = utils_js.isJquery(el) ? el : $(el);
  this.$items = this.$el.find(itemSelector);
  this.itemsCount = this.$items.length;

  this.currentIndex = this.config.currentIndex;
}

CarouselBase.prototype.prev = function () {
  if (this.currentIndex > 0) {
    this.goToIndex(this.currentIndex - 1);
  } else {
    this.goToIndex(this.itemsCount - 1);
  }
};

CarouselBase.prototype.next = function () {
  if (this.currentIndex < this.itemsCount - 1) {
    this.goToIndex(this.currentIndex + 1);
  } else {
    this.goToIndex(0);
  }
};

CarouselBase.prototype.start = function () {
  this.goToIndex(this.currentIndex);
  if (this.itemsCount > 1) {
    this.timeout = setTimeout(this._loop.bind(this), this.config.duration);
  }
};

CarouselBase.prototype.stop = function () {
  return clearTimeout(this.timeout);
};

CarouselBase.prototype._loop = function () {
  this.next();
  this.timeout = setTimeout(this._loop.bind(this), this.config.duration);
};

module.exports = CarouselBase;
